import FormattedMessage from 'I18n/components/FormattedMessage';
import { Breadcrumbs } from 'foundations-components/transitional/components/Breadcrumbs';
import { useParams } from 'react-router-dom';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { Paths } from '../../constants/paths';
import { useRouteReferrer } from '../../context/RouteReferrerContext';
import { useBackBreadcrumbLocation } from '../hooks/useBackBreadcrumbLocation';
import { useBreadcrumbs } from '../hooks/useBreadcrumbs';
import { RouteReferrerBackLink } from './RouteReferrerBackLink';
import { jsx as _jsx } from "react/jsx-runtime";
function getBreadcrumbTestId(pathKey, title) {
  if (pathKey) {
    switch (pathKey) {
      case 'HOME':
        return 'storefront-breadcrumb-marketplace';
      case 'APPS':
        return 'storefront-breadcrumb-apps';
      case 'AGENTS':
        return 'storefront-breadcrumb-breeze-agents';
      case 'SEARCH_RESULTS':
        return 'storefront-breadcrumb-all-products';
      case 'FEATURED':
        return 'storefront-breadcrumb-collections';
      case 'FEATURED_COLLECTION':
      case 'LISTING_DETAILS':
        if (typeof title === 'string') {
          return `storefront-breadcrumb-${title.toLowerCase().replace(/\s+/g, '-')}`;
        }
        return 'storefront-breadcrumb-dynamic';
      default:
        return 'storefront-breadcrumb-unknown';
    }
  }
  return 'storefront-breadcrumb-unknown';
}
export function StorefrontBreadcrumbs({
  title,
  pathKey,
  backBreadcrumb,
  productType
}) {
  const referrer = useRouteReferrer();
  const {
    collectionSlug,
    listingSlug
  } = useParams();
  const items = useBreadcrumbs({
    title,
    pathKey,
    backBreadcrumb,
    productType,
    slug: collectionSlug || listingSlug
  });
  const backBreadcrumbLocation = useBackBreadcrumbLocation();
  if (referrer) {
    return /*#__PURE__*/_jsx(Breadcrumbs, {
      flush: true,
      marginBlockStart: "0",
      "data-test-id": "storefront-breadcrumbs",
      children: /*#__PURE__*/_jsx(RouteReferrerBackLink, {
        referrer: referrer
      })
    });
  }
  return /*#__PURE__*/_jsx(Breadcrumbs, {
    flush: true,
    marginBlockStart: "0",
    "data-test-id": "storefront-breadcrumbs",
    children: backBreadcrumb ? /*#__PURE__*/_jsx(RouterLink, {
      to: backBreadcrumbLocation !== null && backBreadcrumbLocation !== void 0 ? backBreadcrumbLocation : Paths.HOME,
      "data-test-id": "storefront-back-breadcrumb",
      children: /*#__PURE__*/_jsx(StorefrontBreadcrumbMessage, {
        backBreadcrumb: true
      })
    }) : items === null || items === void 0 ? void 0 : items.map((item, index) => /*#__PURE__*/_jsx("span", {
      "data-test-id": getBreadcrumbTestId(item.pathKey, item.title),
      children: /*#__PURE__*/_jsx(StorefrontBreadcrumbItem, {
        item: item
      })
    }, `${item.pathKey}-${index}`))
  });
}
function StorefrontBreadcrumbItem({
  item
}) {
  if (item.isCurrentPage) {
    return /*#__PURE__*/_jsx(StorefrontBreadcrumbMessage, {
      title: item.title,
      pathKey: item.pathKey
    });
  }
  if (item.pathKey) {
    return /*#__PURE__*/_jsx(RouterLink, {
      to: item.slug ? Paths[item.pathKey].replace(':slug', item.slug) : Paths[item.pathKey],
      children: /*#__PURE__*/_jsx(StorefrontBreadcrumbMessage, {
        title: item.title,
        pathKey: item.pathKey
      })
    });
  }
  return null;
}
function StorefrontBreadcrumbMessage({
  backBreadcrumb,
  pathKey,
  title
}) {
  if (backBreadcrumb) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplaceStorefront.breadcrumbs.back"
    });
  }
  switch (pathKey) {
    case 'HOME':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.marketplace"
      });
    case 'APPS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.apps"
      });
    case 'AGENTS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.agents"
      });
    case 'SEARCH_RESULTS':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.explore"
      });
    case 'FEATURED':
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplaceStorefront.breadcrumbs.featured"
      });
    case 'FEATURED_COLLECTION':
    case 'LISTING_DETAILS':
      return title || '';
    default:
      return '';
  }
}